
import "./whoweare.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useEffect } from "react";

export default function Whoweare() {

    useEffect(() => { window.scrollTo(0, 0); }, []);


    return(
            <div className="context">

            <Header access={0}></Header>

            <div className="content">
                <div className="ft_topico">Tecnologia de atendimento inteligente</div>
                <div className="ft_descricao">A Winners AI nasceu para transformar a forma como empresas se comunicam com seus clientes, utilizando inteligência artificial para automatizar atendimento, organizar agendas e melhorar a experiência do usuário.</div>
                <div className="space"></div>
                <div className="ft_topico">Sobre a Winners AI</div>
                <div className="ft_descricao">A Winners AI é uma startup de tecnologia fundada em julho de 2025 e conduzida pela empresa Winners Ltda (CNPJ 10.214.659/0001-02).</div>
                <div className="ft_descricao">Nossa plataforma foi criada para ajudar empresas a automatizar processos de atendimento utilizando agentes de inteligência artificial capazes de conversar, agendar compromissos e resolver dúvidas de clientes de forma rápida e eficiente.</div>
                <div className="space"></div>
                <div className="ft_topico">O problema que resolvemos</div>
                <div className="ft_descricao">Empresas modernas precisam atender clientes em múltiplos canais, 24 horas por dia.</div>
                <div className="ft_descricao">Muitos negócios ainda dependem de atendimento manual, o que gera demora nas respostas, perda de oportunidades e sobrecarga da equipe.</div>
                <div className="ft_descricao">A Winners AI resolve esse problema criando agentes inteligentes capazes de atender clientes automaticamente, mantendo qualidade e disponibilidade contínua.</div>
                <div className="space"></div>
                <div className="ft_topico">Missão</div>
                <div className="ft_descricao">Democratizar o acesso à inteligência artificial aplicada ao atendimento, permitindo que empresas de qualquer tamanho possam oferecer experiências rápidas, eficientes e inteligentes aos seus clientes.</div>
                <div className="space"></div>
                <div className="ft_topico">Visão</div>
                <div className="ft_descricao">Ser uma referência em soluções de automação de atendimento com inteligência artificial na América Latina.</div>
                <div className="space"></div>
                <div className="ft_topico">Valores:</div>
                <div className="ft_descricao">🚀 Inovação: buscamos constantemente novas formas de aplicar inteligência artificial para resolver problemas reais.</div>
                <div className="ft_descricao">🤝 Transparência: construímos relações baseadas em confiança com clientes e parceiros.</div>
                <div className="ft_descricao">⚡ Eficiência: criamos soluções que economizam tempo e aumentam a produtividade.</div>
                <div className="ft_descricao">🌎 Acessibilidade: acreditamos que tecnologia avançada deve ser acessível para todos os negócios.</div>

                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>

            </div>

            <Footer access={0}></Footer>

        </div>
    )
}